import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { SharedModule } from 'src/app/shared';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { CustomersGroupComponent } from './customers-group.component';
import { CustomersGroupAddComponent } from './customers-group-add/customers-group-add.component';
import { CustomersGroupUpdateComponent } from './customers-group-update/customers-group-update.component'
@NgModule({
  declarations: [
    CustomersGroupComponent,
    CustomersGroupAddComponent,
    CustomersGroupUpdateComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgZorroAntdModule,
    SharedModule,
    NzTabsModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    CustomersGroupComponent
  ]
})
export class CustomersGroupModule { }
